import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Auth from './authentication';
// import './styles/index.css';
import '@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css';
import '@maersk-global/mds-foundations/css/foundations.css';

const container = document.getElementById('root');
const root = createRoot(container);


root.render(
    <BrowserRouter>
      <Auth />
    </BrowserRouter>
);